import { handleNetworkError, showSuccessToast } from '../../utils';
import formatDate from 'date-fns/format';
import { setBankBalanceApproved, setBankBalanceRejected, persistBankBalance, fetchBankBalances } from '../../services/API';
import router from '../../router';

export const getBankBalances = async ({ commit }) => {
  commit('FETCHING_BANK_BALANCES', true);

  try {
    let {data, pagination} = await fetchBankBalances();
    data = data.map(bankBalance => {
        if(bankBalance.date){
          bankBalance.date = formatDate(new Date(bankBalance.date), 'MMMM YYYY');
          bankBalance.time = formatDate(new Date(bankBalance.date), 'HH:mm');
        }

        return bankBalance;
      });

    commit('FETCHING_BANK_BALANCES', false);
    commit('SET_BANK_BALANCES', {data, pagination});
  } catch (error) {
    commit('FETCHING_BANK_BALANCES', false);
    handleNetworkError(error, "Error fetching bank balances:");
  }
}

export const recordBankBalance = async ({ state, commit }, data) => {
  commit('CREATING_BANK_BALANCE', true);

  try {
    const response = await persistBankBalance(data);
    const bankBalance = response.data;
    bankBalance.date = formatDate(new Date(bankBalance.date), 'MMMM YYYY');
    commit('CREATING_BANK_BALANCE', false);
    let bankBalances = state.bankBalances || [];

    bankBalances.unshift(bankBalance);

    commit('SET_BANK_BALANCES', {data: bankBalances});
    showSuccessToast("Bank balance created");
    router.replace('/bankBalances/');
  } catch (error) {
    commit('CREATING_BANK_BALANCE', false);
    handleNetworkError(error, "Error creating bank balance:");
  }
}

export const approveBankBalance = async ({commit}, bankBalanceId) => {
  try {
    commit('UPDATE_BANK_BALANCE', {bankBalanceId, changes: {approving: true}});
    await setBankBalanceApproved(bankBalanceId);
    const changes = {approving: false, approvalStatus: 1, paidAt: new Date()};
    commit('UPDATE_BANK_BALANCE', {bankBalanceId, changes});
  } catch (error) {
    commit('UPDATE_BANK_BALANCE', {bankBalanceId, changes: {approving: false}});
    handleNetworkError(error, "Error approving transaction:");
  }
}

export const rejectBankBalance = async ({commit}, {bankBalanceId, remark}) => {
  try {
    commit('UPDATE_BANK_BALANCE', {bankBalanceId, changes: {rejecting: true}});
    await setBankBalanceRejected(bankBalanceId, remark);
    const changes = {rejecting: false, approvalStatus: 2};
    commit('UPDATE_BANK_BALANCE', {bankBalanceId, changes});
    showSuccessToast("Bank balance entry rejected");
  } catch (error) {
    commit('UPDATE_BANK_BALANCE', {bankBalanceId, changes: {rejecting: false}});
    handleNetworkError(error, "Error rejecting bank balance:");
  }
}
